// Loader
class LoaderCollection {
  constructor(selectors) {
    this.selectors = selectors;
    this.collection = [];
    this.id = 0;

    this.init();
  }

  init() {
    this.selectors.forEach(selector => {
      const elements = jQuery(selector);

      if (elements.length > 0) {
        elements.each((index, element) => {
          this.create(element);
        });
      }
    });
  }

  create(element) {
    this.collection.push(new Loader(element, this.id++));
  }
}

class Loader {
  constructor(form, index) {
    this.id = index;
    this.form = form;

    this.render();
    this.listen();
  }

  get template() {
    let html = document.createElement("div");

    html.classList.add("syn-loader");

    html.innerHTML = `<div class="loader__wrapper">
                    <i class="loader__image" />
                </div>`;

    return html;
  }

  render() {
    this.form.appendChild(this.template);
  }

  listen() {
    jQuery(this.form).on("wpcf7submit", () => {
      this.hide();
    });

    jQuery(this.form).on(
      "wpcf7mailsent wpcf7mailfailed wpcf7invalid wpcf7spam",
      () => {
        this.hide();
      }
    );

    jQuery(this.form).on("loader:show", () => {
      this.show();
    });

    jQuery(this.form).on("loader:hide", () => {
      this.hide();
    });
  }

  show() {
    if (
      this.form.tagName === "BODY" ||
      this.form.parentNode.tagName === "BODY"
    ) {
      this.form.classList.add("loader-lock");
    }

    this.form.classList.add("loader-is-active");
  }

  hide() {
    if (
      this.form.tagName === "BODY" ||
      this.form.parentNode.tagName === "BODY"
    ) {
      this.form.classList.remove("loader-lock");
    }

    this.form.classList.remove("loader-is-active");
  }
}

export { LoaderCollection, Loader };